import { Pipe, PipeTransform } from '@angular/core';
import { StatisticsExtractor } from 'app/trello/utility/statistics-extractor';

@Pipe({
  name: 'groupCounts',
  pure: true,
})
export class GroupCountsPipe implements PipeTransform {

  constructor(
    private readonly statisticsExtractor: StatisticsExtractor,
  ) {
  }

  transform(
    values:
      {
        [group: string]: any[],
      }
      |
      {
        [outerGroup: string]: {
          [innerGroup: string]: any[],
        },
      }
      |
      undefined,
  ): {
    group: string;
    count: number;
  }[] {
    return this.statisticsExtractor.aggregateCountsByGroup(values);
  }

}
